import React from "react";

const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center z-50">
      <div className="text-center">
        {/* AMS Logo */}
        <div className="mb-8 flex justify-center">
          <img
            src="/assets/images/logo/logo.png"
            alt="AMS Logo"
            className="w-24 h-24 object-contain animate-pulse"
          />
        </div>

        {/* Starting Up Text */}
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Loading Data</h1>

        {/* Loading Animation */}
        <div className="flex justify-center items-center space-x-2 mb-6">
          <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"></div>
          <div
            className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"
            style={{ animationDelay: "0.1s" }}
          ></div>
          <div
            className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"
            style={{ animationDelay: "0.2s" }}
          ></div>
        </div>

        {/* Loading Bar */}
        <div className="w-64 bg-gray-200 rounded-full h-2 mx-auto">
          <div className="bg-gradient-to-r from-blue-500 to-indigo-600 h-2 rounded-full animate-pulse"></div>
        </div>

        {/* Loading Text */}
        <p className="text-gray-600 mt-4 text-sm">Initializing AMS System...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
